import React from 'react'
import styled from 'styled-components'
import axios from 'axios'

import Reveal from '../../common/Reveal'
import Loading from '../../common/Loading'
import Button from '../../common/Button'

import zebra from '../../../images/zebra2.jpg'

const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  background-color: ${props => props.theme.secondary.bg3};
  position: relative;
  z-index: 1;
  padding: 2em;
  text-align: center;
  
  .home-listen-inner {
    position: relative;
    width: 100%;
    max-width: 1000px;
  }

  .home-listen-body {
    background-color: ${props => props.theme.main.bg};
    border-radius: 3px;
    padding: 1.5em;
    color: ${props => props.theme.main.bg};

    h2 {
      color: #fff;
      display: block;
      margin: 0 auto 1em;
      font-size: 1.8em;
      padding-top: 1.35em;
      height: 5em;
      width: 5em;
      background-color: ${props => props.theme.secondary.bg2};
      border-radius: 100%;
      text-shadow: 3px 3px 0 ${props => props.theme.secondary.bg};
    }
    
    h3 {
      margin-bottom: 1.5em;
      font-size: 1em;
      color: #fff;
    }
  }

  .home-listen-link, .home-listen-link-placeholder {
    &:not(:last-child) {
      margin-bottom: 1em;
    }
  }

  .home-listen-link-placeholder {
    border-radius: 4px;
    height: 166px;

    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 1em;
      background: url(${zebra}) repeat;
      border-radius: 4px;
      height: 100%;
    }

    button {
      border-color: ${props => props.theme.secondary.bg2};
      color: ${props => props.theme.secondary.bg2};
      transition: background-color 0.2s ease;

      &:hover {
        background-color: ${props => props.theme.secondary.bg2};
        color: #fff;
      }
    }

    @media screen and (min-width: 801px) {
      div {
        flex-direction: row;
      }

      p {
        margin-right: 2em;
        margin-bottom: 0;
      }
    }
  }

  .video-embed.url-loaded {
    background-color: #f3f3f3;
    height: auto;

    .video-embed-inner {
      padding-bottom: 56.25%;
      position: relative;

      iframe {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  iframe {
    width: 100%;
    background-color: #f3f3f3;
    display: block;
  }

  @media screen and (min-width: 801px) {
    padding: 4em 50px;

    .home-listen-body {
      width: 100%;
      padding: 2.5em;

      h3 {
        font-size: 1.8em;
        margin-bottom: 1.2em;
      }
    }

    .home-listen-link, .home-listen-link-placeholder {
      &:not(:last-child) {
        margin-bottom: 1.5em;
      }
    }
    
  }

`

export default class HomeListen extends React.PureComponent {
  state = { urlLoaded: [] }
  loadUrl = this.loadUrl.bind(this)

  loadUrl (url) {
    if (this.state.urlLoaded.indexOf(url) !== -1) return
    this.setState(prev => ({ urlLoaded: [url, ...prev.urlLoaded] }))
  }

  render () {
    const { urlLoaded } = this.state
    const { listen } = this.props
    return (
      <Wrapper className="home-listen">
        <div className="home-listen-inner">
          <div className="home-listen-body">
            <Reveal>
              <h2>Have A Listen</h2>
              <h3>A few tracks made at Bagnall Hill...</h3>
            </Reveal>
            { listen !== null
              ? listen.map(link => {
                const videoClass = link.url.indexOf('youtube') !== -1 || link.url.indexOf('vimeo') !== -1 ? 'video-embed' : ''
                return (
                  urlLoaded.indexOf(link.url) < 0
                    ? <Reveal key={link.url} className={`home-listen-link-placeholder ${videoClass}`}>
                        <div>
                          <p>{link.title}</p>
                          <Button click={() => this.loadUrl(link.url)}>PLAY SONG</Button>
                        </div>
                      </Reveal>
                    : <div key={link.url} className={`home-listen-link ${videoClass} url-loaded`}>
                        <div className="video-embed-inner" dangerouslySetInnerHTML={{ __html: link.url }} />
                      </div>
                )
              })
              : <Loading color="#ff486a" />
            }
          </div>
        </div>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/home/HomeListen.js